import { Injectable } from '@angular/core';
import { ModelCache } from '../model-cache/model-cache';
import { ModeModelBase } from './model';
import { ModelAccessorBase } from './model_accessor';

@Injectable({ providedIn: 'root' })
export class ModelNameService {
  cache: ModelCache.Cache;
  constructor(modelCache: ModelCache) {
    this.cache = modelCache.getOrCreate('model._modelNames');
  }
  put<Model extends ModeModelBase, Accessor extends ModelAccessorBase<Model>>(name: string, model: Accessor): void {
    this.cache.put(name, model);
  }

  get<Model extends ModeModelBase, Accessor extends ModelAccessorBase<Model>>(name: string): Accessor {
    return this.cache.get(name);
  }
}
